import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c2ea549"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emEdicao" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Edição de Modelo", -1))
const _hoisted_3 = {
  key: 1,
  class: "erro"
}
const _hoisted_4 = {
  key: 2,
  class: "erro"
}
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IdFormularioFactory = _resolveComponent("IdFormularioFactory")!
  const _component_TituloInput = _resolveComponent("TituloInput")!
  const _component_ListaDeEscapadores = _resolveComponent("ListaDeEscapadores")!
  const _component_TextoModeloInput = _resolveComponent("TextoModeloInput")!
  const _component_BotoesSalvarCancelar = _resolveComponent("BotoesSalvarCancelar")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_IdFormularioFactory, {
      titulo: (_ctx.titulo as Titulo),
      onGerouId: _ctx.gerouId
    }, null, 8, ["titulo", "onGerouId"]),
    _createVNode(_component_TituloInput, {
      titulo: (_ctx.titulo as Titulo),
      onDigitou: _ctx.digitouTitulo
    }, null, 8, ["titulo", "onDigitou"]),
    (_ctx.escapadores)
      ? (_openBlock(), _createBlock(_component_ListaDeEscapadores, {
          key: 0,
          escapadoresQuestoes: _ctx.escapadores
        }, null, 8, ["escapadoresQuestoes"]))
      : _createCommentVNode("", true),
    _createVNode(_component_TextoModeloInput, {
      textoModelo: (_ctx.textoModelo as TextoModelo),
      onDigitou: _ctx.digitouTextoModelo
    }, null, 8, ["textoModelo", "onDigitou"]),
    (_ctx.escapadoresInexistentes.length)
      ? (_openBlock(), _createElementBlock("article", _hoisted_3, [
          _createTextVNode(" Foram escritos escapadores inexistentes: "),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.escapadoresInexistentes, (escapador, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(escapador.toString()), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.erro)
      ? (_openBlock(), _createElementBlock("article", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.erro) + " ", 1),
          (_ctx.inconsistencias.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createTextVNode(" Inconsistências: "),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inconsistencias, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("footer", null, [
      _createVNode(_component_BotoesSalvarCancelar, {
        onCancelou: _ctx.cancelar,
        onSalvou: _ctx.salvar
      }, null, 8, ["onCancelou", "onSalvou"])
    ])
  ]))
}